<template>
    <div class="container-fluid py-2 my-2">

        <div class="col-sm-12 row align-items-center">
            <!-- <div class="row"> -->

                <div class="d-flex align-items-center">
                    <span class="glued-right">
                        <i class="ico ico-calendar fs-normal dark m-0"></i>
                    </span>
                    <date-picker-new class=""
                        v-model="filters.dateRange"
                        :enableClear="false"
                        :range="true"
                        :showFromTo="false"
                        @input="filterChanged">
                    </date-picker-new>

                </div>

                <!-- <div class="col-sm-2">
                    <v-select :options="editedResources" label="name" v-model="selectedResource" :on-change="changedResource(selectedResource)"></v-select>
                </div>

                <div class="col-sm-2">
                    <v-select :options="editedDurations" label="name" v-model="filters.duration"></v-select>
                </div> -->

            <!-- </div> -->
        </div>

    </div>
</template>

<script>
import DatePickerNew from 'vue-date'
import extendedVSelect from '@/extends/vue-select'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    mixins: [reservationsMixin],
    data: function() {
        return {
            // filters:{
            //     dateRange: null,
            //     resourceId: null,
            //     duration: null,
            // },
            selectedResource: null,
            datePickerShortcuts: [
                {
                    text: 'Next 7 Days',
                    start: new Date(),
                    end: new Date(Date.now() + 3600 * 1000 * 24 * 7)
                },
                {
                    text: 'Next 30 days',
                    start: new Date(),
                    end: new Date(Date.now() + 3600 * 1000 * 24 * 30)
                }
            ]
        }
    },
    props: {
        filters: {
            type: Object
        },
        availableResources:{
            type: Array,
            default: []
        },
        availableDurations:{
            type: Array,
            default: []
        }
    },
    computed: {
        editedResources: function(){
            if(this.availableResources){
                //this JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                let resourcesEdited = JSON.parse(JSON.stringify(this.availableResources));

                resourcesEdited.unshift({
                    id: null,
                    name: 'All resources'
                });

                //set default dropdown
                if(this.selectedResource == null){
                    // this.selectedResource = resourcesWithAvailability[0]
                    this.selectedResource = this.firstResourceWithAvailability()
                }

                return resourcesEdited;
            } else {
                return [];
            }
        },
        editedDurations: function(){
            if(this.availableDurations){
                //this JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                let durationsEdited = JSON.parse(JSON.stringify(this.availableDurations));

                durationsEdited.unshift({
                    id: null,
                    name: 'All durations'
                });

                //set default dropdown
                if(this.filters.duration == null){
                    this.filters.duration = durationsEdited[0]
                }

                return durationsEdited;
            } else {
                return [];
            }
        },
    },
    methods: {
        changedResource: function(selectedResource) {
            // if(selectedResource.id){
            //     this.filters.resourceId = selectedResource.id;
            // }
        },
        filterChanged: function() {
            this.$emit('filterChanged', this.filters);
        }
    },
    components: {
        DatePickerNew,
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Filters.vue?0cb722cb